import { useMemo } from "react";
import { SimpleAreaChartProps } from "../SimpleAreaChart.types";
import { AreaChartProps } from "../../AreaChart.types";
import { SimpleDataPoints } from "../utils/SimpleDataPoints";

export default function useSimpleAreaChart({ data: dataProp, labels, ...rest }: SimpleAreaChartProps): AreaChartProps {
    const data: AreaChartProps["data"] = useMemo(
        () => ({
            labels,
            datasets: dataProp.map((item) => SimpleDataPoints.toDataset(item)),
        }),
        [dataProp, labels],
    );

    return {
        data,
        ...rest,
    };
}
